import React from 'react'
import Sidebar from './Sidebar'
import { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
const Category = () => {
let{id} = useParams()
    const [post, setpost] = useState([])
    const img = "https://webeetec.com/itsharks24/blog/admin/";
    useEffect(() => {
        fetch("https://webeetec.com/itsharks24/blog/api/getcategory.php" + id )
            .then(r => r.json())
            .then((r) => {
                // console.log(r);
                setpost(r);
            }
            )
    }, [])
    return (
        <>

            <section className="container">
                <div className="wrapper clear">

                    <div className="contentLeft">
                        <div className="archivePageTitle"><span>Lifestyle</span></div>
                        <div className="archivePostWrap">

                            {
                                post.map((cat) => {



                                    return (

                    <div className="archivePostItem">
                        <div className="archivePostTime">15.05.2015</div>
                        <h3 className="archivePostTitle"><a href="#"></a> {cat.name}</h3>
                        <a href="single.html" className="archivePostCategory">Lifestyle</a>
                        <a href="single.html" className="archivePostImg">
                            <img src={img} alt="Francoise img" />
                        </a>
                        <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident.</p>
                        <div className="archivePostItemMeta">
                            <a href="#" className="archivePostItemComments">124 Comments</a>
                            <div className="archivePostItemShareLinks">
                                <a href="#"><i className="fa fa-facebook"></i></a>
                                <a href="#"><i className="fa fa-twitter"></i></a>
                                <a href="#"><i className="fa fa-pinterest"></i></a>
                            </div>
                            <a href="single.html" className="archivePostReadMore">Read More</a>
                        </div>
                    </div>


                )

            })
        }





    </div>
    <div className="postPagination">
        <ul className="clear">
            <li className="newPosts"><a href="#">New posts</a></li>
            <li className="olderPosts"><a href="#">Older posts</a></li>
        </ul>
    </div>
</div>
<Sidebar />
</div>
<div className="clear"></div>

</section>


</>
)
}

export default Category